import { hasEditPermission } from '@pmp-qrtool/lib-api-domain/utils/permissions';
import { CodePermission } from '@pmp-qrtool/lib-api-domain/models/qr';
import { CodeV2 as Code } from '@/redux/apis/codes-api';
import { User } from '@/redux/apis/frontend-api';

export const canUserEditCode = (code: Code, user: User): boolean => {
  return hasEditPermission({
    permissions: code.permissions as CodePermission[] | undefined,
    username: user.username,
    userLocation: user.cdsLocation,
  });
};
